import AppleLogo from '../../components/assets/images/apple.png'
import GoogleLogo from '../../components/assets/images/google.png'
import MoreIcon from '../../components/assets/images/icone-mais.png'
import PixLogo from '../../components/assets/images/icone-pix.png'
import SigaPayIcon from '../../components/assets/images/icone-sigapay.png'
import WhatsappIcon from '../../components/assets/images/icone-whats.png'
import SigaPayLogo from '../../components/assets/images/logo_sigapay.png'
import ZabLogo from '../../components/assets/images/logo-zab.png'

function Home() {
  return (
    <div className="page-container">
      <header>
        <img className="logo-sigapay-img" src={SigaPayLogo} alt="SigaPay Logo" />
        <span className="portal-servicos-btn">Portal de Serviços</span>
      </header>
      <main>
        <div className="welcome-text">
          <h1>Olá!</h1>
          <p>Escolha uma opção e siga tranquilo</p>
        </div>
        <section className="options-grid">
          <a
            href="https://pix.sigapay.com.br/estacionar"
            className="option-link"
            style={{ backgroundColor: 'var(--azul-escuro)' }}
          >
            <img className="main-icon" src={PixLogo} alt="Pix" />
            <span className="main-text">Estacione com Pix</span>
          </a>
          <a
            href="https://pix.sigapay.com.br/regularizar"
            className="option-link"
            style={{ backgroundColor: 'var(--azul-claro)' }}
          >
            <img className="main-icon" src={PixLogo} alt="Pix" />
            <span className="main-text">Regularize com Pix</span>
            <span className="small-text">ACT | AVISOS</span>
          </a>
          <a
            href="https://apps.apple.com/us/app/sigapay/id1611349864"
            className="option-link"
            style={{ backgroundColor: 'var(--azul-claro)' }}
          >
            <img className="main-icon" src={SigaPayIcon} alt="SigaPay" />
            <span className="main-text">Baixe o APP Sigapay</span>
            <span className="app-store-logos">
              <img src={AppleLogo} alt="App Store" />
            </span>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.zonaazulbrasil.sigapay&hl=pt_BR"
            className="option-link"
            style={{ backgroundColor: 'var(--azul-escuro)' }}
          >
            <img className="main-icon" src={SigaPayIcon} alt="SigaPay" />
            <span className="main-text">Baixe o APP Sigapay</span>
            <span className="app-store-logos">
              <img src={GoogleLogo} alt="Google Play" />
            </span>
          </a>
          <a
            href="https://wa.me/5511996107899"
            className="option-link"
            style={{ backgroundColor: 'var(--azul-escuro)' }}
          >
            <img className="main-icon" src={WhatsappIcon} alt="WhatsApp" />
            <span className="main-text">Fale Conosco</span>
          </a>
          <a
            href="https://zonaazulbrasil.com.br"
            className="option-link"
            style={{ backgroundColor: 'var(--azul-claro)' }}
          >
            <img className="icon-plus-img" src={MoreIcon} alt="Mais" />
            <span className="main-text">Serviços</span>
            <span className="small-text">INFORMAÇÕES</span>
          </a>
        </section>
      </main>
      <footer>
        <div className="logo-zab">
          <img src={ZabLogo} alt="Zona Azul Brasil Logo" />
        </div>
      </footer>
    </div>
  )
}

export default Home
